module.exports = __webpack_public_path__ + "static/img/workflow_1.31142ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ngs_second/transcriptome/sequencing/workflow_1.png
// module id = eDgI
// module chunks = 16